import React from "react";
import TutorialDetailsMain from "../components/TutorialDetailsMain";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";

const TutorialDetails = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Tutorial Details */}
      <TutorialDetailsMain />

      {/* Footer One */}
      <Footer />
    </>
  );
};

export default TutorialDetails;
